module.exports = __webpack_public_path__ + "static/img/ycks5.b5b081d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/appopen/appopen/ycks5.png
// module id = LU2i
// module chunks = 0